<template>
  <!-- 续期费用记录 -->
  <div class="content main-container">
    <loading :isShow="$root.$children[0].isShowLoading" />
    <div class="search-tools">
      <div class="search-box btn3" :class="{'close':!searchMore}">
        <div class="input-item">
          <span class="label">供应商类型</span>
          <RadioGroup v-model="searchParams.supplierType" @on-change="changeSupplierType">
            <Radio label="">全部</Radio>
            <Radio label="1">保险公司</Radio>
            <Radio label="2">合作通道</Radio>
          </RadioGroup>
        </div>
        <div class="input-item" v-if="searchParams.supplierType">
          <span class="label">供应商</span>
          <Select v-model="searchParams.supplierIds" multiple :max-tag-count="4" clearable filterable transfer>
            <Option :value="item.id" v-for="(item, index) in supplierList" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">保单年度</span>
          <Input v-model="searchParams.commissionIndex" placeholder="请输入正整数" type="number" @on-change="changeValue('commissionIndex')" />     
        </div>
        <div class="input-item">
          <span class="label" style="width:105px;">交费期次</span>
          <Input v-model="searchParams.commissionPeriods" placeholder="请输入正整数" type="number" @on-change="changeValue('commissionPeriods')" />
        </div>
        <div class="input-item">
          <span class="label">保险公司</span>
          <Select v-model="searchParams.companyCode" clearable filterable transfer>
            <Option
              v-for="(bean, i) in companyLists"
              :key="i"
              :value="bean.code"
              >{{ bean.name }}</Option
            >
          </Select>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.dateType" :transfer="true" @on-change="changeDateType">
            <Option value="1">投保日期</Option>
            <Option value="2">承保日期</Option>
            <Option value="3">生效日期</Option>
          </Select>
          <DatePicker v-model="searchParams.date" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime"></DatePicker>
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.dateType1" :transfer="true" @on-change="changeDateType1">
            <Option value="1">应收日期</Option>
            <Option value="2">宽限期满日</Option>
          </Select>
          <DatePicker v-model="searchParams.date1" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime1"></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">实收日期</span>
          <DatePicker v-model="searchParams.actualReceiveTime" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime2"></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">退保日期</span>
          <DatePicker v-model="searchParams.refundTime" type="daterange" split-panels separator=" 至 " :transfer="true"
            placement="bottom" format="yyyy-MM-dd" placeholder="选择日期" @on-change="changeTime4" :disabled="searchParams.isNull3"></DatePicker>
            <Checkbox v-model="searchParams.isNull3" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">保单号</span>
          <Input
            v-model="searchParams.policyNo"
            placeholder="请输入"
            clearable
          />
        </div>
        <div class="input-item">
          <span class="label">保单状态</span>
          <Select v-model="searchParams.policyStatusList" clearable multiple>
            <Option value="1">已承保</Option>
            <Option value="-1">已退保</Option>
            <Option value="0">已终止</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">险种分类</span>
          <Select v-model="searchParams.themeIds" clearable filterable multiple>
            <Option v-for="(item, index) in themeList" :value="item.id" :key="index">{{ item.name }}</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">业务类别</span>
          <Select v-model="searchParams.sellType" :transfer="true" clearable :disabled="searchParams.sellTypeNull">
            <Option value="1">网销</Option>
            <!-- <Option value="2">电销</Option> -->
            <Option value="3">经代</Option>
          </Select>
          <Checkbox v-model="searchParams.sellTypeNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>
        <div class="input-item">
          <span class="label">上游结算状态</span>
          <Select v-model="searchParams.settlementStatus" transfer placeholder="请选择" clearable>
            <Option value="1">已结算</Option>
            <Option value="0">未结算</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">对账状态</span>
          <Select v-model="searchParams.reconciliationStatus" clearable>
            <Option value="0">未对账</Option>
            <Option value="1">对账正常</Option>
            <Option value="2">对账异常</Option>
            <Option value="3">已对账</Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">对账日期</span>
          <DatePicker transfer v-model="searchParams.checkDate" format="yyyy-MM-dd" type="date"  @on-change="searchParams.checkDate = $event"
            placeholder="请选择" :disabled="searchParams.isNull2"></DatePicker>
            <Checkbox v-model="searchParams.isNull2" class="null" @on-change="changeDateNull">为空</Checkbox>
        </div>
        <div class="input-item">
            <span class="label">所属对账单</span>
            <Select v-model="searchParams.reconciliationId" clearable filterable transfer :disabled="searchParams.reconciliationNull">
              <Option :value="item.reconciliationId" v-for="(item, index) in queryList" :key="index" >{{ item.reconciliationName }}</Option>
            </Select>
            <Checkbox v-model="searchParams.reconciliationNull" class="null" @on-change="changeTypeNull">为空</Checkbox>
        </div>  
        <div class="input-item" v-if="searchParams.tab == 2 || searchParams.tab == 3">
          <span class="label">结算日期</span>
          <DatePicker transfer v-model="searchParams.settleDate" format="yyyy-MM-dd" type="date"
            placeholder="请选择"></DatePicker>
        </div>
        <div class="input-item" v-if="searchParams.tab == 2 || searchParams.tab == 3">
            <span class="label">所属结算单</span>
            <Select v-model="searchParams.settleReportId" clearable filterable transfer>
              <Option :value="item.settleReportId" v-for="(item, index) in settleReportList" :key="index" >{{ item.settleReportName }}</Option>
            </Select>
        </div>  
        <div class="input-item">
          <span class="label">出单机构/团队</span>
          <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">出单业务员</span>
          <Select clearable v-model="searchParams.salesmanId" style="width:256px;" filterable :transfer="true">
            <Option :value="item.id" v-for="(item, index) in salesmanList" :key="index"
              :label="item.staffNo + (item.staffNo ? '/' : '') + item.name"></Option>
          </Select>
        </div>
        <div class="input-item">
          <span class="label">费用类型</span>
          <Select v-model="searchParams.commissionType" clearable>
            <Option value="3">续期基础费用</Option>
            <Option value="4">续年度服务津贴</Option>
          </Select>
        </div>
        <div class="input-item" v-if="searchParams.tab =='1'">
          <span class="label">是否已回款</span>
          <RadioGroup
            v-model="searchParams.receivableStatus"
            @on-change="searchAjax()"
          >
            <Radio label="">全部</Radio>
            <Radio label="1">已回款</Radio>
            <Radio label="0">未回款</Radio>
          </RadioGroup>
        </div>

        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch();selectTreeId=''">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore=false">收起<Icon type="ios-arrow-up" /></Button>
          <Button type="primary" ghost v-else @click="searchMore=true">展开<Icon type="ios-arrow-down" /></Button>
        </div>
      </div>
      <div class="tab-box">
        <Tabs v-model="searchParams.tab" :animated="false" @on-click="changeTabs">
          <TabPane
            :label="item.label"
            :name="item.value"
            v-for="item in tabList"
            :key="item.value"
          ></TabPane>
        </Tabs>
        <div class="tools-box left" >
          <Button type="primary" ghost @click="exportForm()">导出</Button>
        </div>
      </div>


      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table
          :columns="columns"
          :data="tableData"
          class="table-wrap"
        >
          <template slot-scope="{ row }" slot="checkName">
            <div @click="lookStatement(row)" class="toDetailPage">
              {{ row.checkName }}
            </div>
          </template>
          <template slot-scope="{ row }" slot="reconciliationStatusDesc">
            <div>
              <i class="dian red" v-if="row.isOk == 2 || row.isOk == 3 || row.isOk == 6"></i>
              {{ row.reconciliationStatusDesc }}
            </div>
          </template>
          <template slot-scope="{ row }" slot="action">
            <span class="table-btn" @click="cycleCheck(row)" v-if="$units.pointAction('offline_10_3')&&searchParams.tab =='2'">核查</span>
            <span class="table-btn" @click="settlement(row)" v-else-if="$units.pointAction('offline_10_3')">核查</span>
          </template>
        </Table>
        <Page
          :total="total"
          :current.sync="pageNum"
          :page-size="pageSize"
          show-total
          @on-change="getList"
          style="text-align: center; margin-top: 20px"
        />
      </div>
    </div>
    <Modal
      title="生成结算批次"
      v-model="addVisible"
      width="500px"
      class-name="commissionRecordModal"
      class="my-modal"
      :mask-closable="false"
    >
      <Form
        ref="addFormRef"
        :model="addForm"
        :rules="addFormRules"
        v-loading="settleLoading"
        class="page-form"
        :label-width="90"
        inline
      >
        <FormItem class="full" label="总单量">
          {{ addForm.num }}
        </FormItem>
        <FormItem class="full" label="总保费">
          {{ addForm.amount }}
        </FormItem>
        <FormItem class="full" label="总费用">
          {{ addForm.checkAmount }}
        </FormItem>
        <FormItem prop="checkId" class="full pc-wrap" label="批次名称">
          <Select
            v-model="addForm.checkId"
            clearable
            @on-change="selectBatch(addForm, $event)"
          >
            <Option
              :value="item.id"
              v-for="(item, i) in batchList"
              :key="i"
              :label="item.checkName"
            ></Option>
          </Select>
          <Button type="primary" ghost @click="addBatch">新增批次</Button>
        </FormItem>
        <FormItem prop="checkDate" class="full" label="结算日期">
          <DatePicker
            format="yyyy-MM-dd"
            :disabled="true"
            v-model="addForm.checkDate"
            type="date"
            placeholder="请选择"
          ></DatePicker>
        </FormItem>
        <FormItem prop="checkUser" class="full" label="核收人">
          <Input
            type="text"
            v-model="addForm.checkUser"
            placeholder="请输入"
            :maxlength="32"
            :show-word-limit="true"
            clearable
          ></Input>
        </FormItem>
        <FormItem prop="consultRemark" class="full" label="备注">
          <Input
            type="textarea"
            :rows="4"
            v-model.trim="addForm.consultRemark"
            :maxlength="300"
            :show-word-limit="true"
            placeholder="请输入"
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="addVisible = false" ghost>取消</Button>
        <Button type="primary" :loading="btnLoading" @click="saveAddform()"
          >保存</Button
        >
      </div>
    </Modal>

    <Modal
      title="结算"
      v-model="settlementShow"
      width="500px"
      class-name="commissionRecordModal"
      class="my-modal"
      :mask-closable="false"
    >
      <Form
        ref="addFormRef1"
        :model="addForm"
        class="page-form formGauge"
        :rules="addFormRules"
        :label-width="110"
        inline
      >
        <FormItem prop="settleDate" class="full" label="结算周期">
          <DatePicker
            v-model="addForm.settleDate"
            format="yyyy-MM-dd"
            type="date"
            placeholder="选择结算周期"
            style="width: 300px"
          ></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="settlementShow = false" ghost
          >取消</Button
        >
        <Button type="primary" @click="saveAddBatch"
          >确认</Button
        >
      </div>
    </Modal>


    <Modal
      title="新增批次"
      v-model="addbatchVisible"
      width="500px"
      class-name="commissionRecordModal"
      class="my-modal"
      :mask-closable="false"
    >
      <Form
        ref="addbatchRef"
        :model="addbatchForm"
        class="page-form formGauge"
        :label-width="80"
        inline
      >
        <FormItem
          prop="checkName"
          class="full"
          label="批次名称"
          :rules="$units.formRule.required()"
        >
          <Input
            type="text"
            v-model.trim="addbatchForm.checkName"
            :maxlength="64"
            :show-word-limit="true"
            placeholder="请输入"
          ></Input>
        </FormItem>
        <FormItem
          prop="checkDate"
          class="full"
          label="结算日期"
          :rules="$units.formRule.required('请选择结算日期', 'change', 'date')"
        >
          <DatePicker
            type="date"
            v-model="addbatchForm.checkDate"
            format="yyyy-MM-dd"
            placeholder="请选择"
          ></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="addbatchVisible = false" ghost
          >取消</Button
        >
        <Button type="primary" @click="saveBatch()">确认</Button>
      </div>
    </Modal>
    <Modal
      title="结算"
      v-model="settlementVisible"
      width="500px"
      class-name="commissionRecordModal"
      class="my-modal"
      :mask-closable="false"
    >
      <Form
        ref="settlementFormRef"
        :model="settlementForm"
        class="page-form formGauge"
        :rules="settlementFormRules"
        :label-width="110"
        inline
      >
        <FormItem prop="checkId" class="full" label="我司批次名称">
          <Select
            v-model="settlementForm.checkId"
            not-found-text="暂无数据，请生成结算批次后结算"
            clearable
            @on-change="selectBatch(settlementForm, $event)"
          >
            <Option
              :value="item.id"
              v-for="(item, i) in batchList"
              :key="i"
              :label="item.checkName"
            ></Option>
          </Select>
        </FormItem>
        <FormItem prop="checkDate" class="full" label="结算日期">
          <DatePicker
            format="yyyy-MM-dd"
            disabled
            v-model="settlementForm.checkDate"
            type="date"
            placeholder="请选择"
          ></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="settlementVisible = false" ghost
          >取消</Button
        >
        <Button type="primary" @click="saveSettlement">确认</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import selectTree from "@/components/system/selectTree3";
import { mapState } from "vuex";
import { pageTool } from "@/api/mixins";
import { upstreamColumns } from "./form/indexColumns";

export default {
  mixins: [pageTool],
  data: () => ({
    supplierList:[],
    settleReportList:[],
    queryList:[],
    themeList: [],
    rowId:null,
    settlementVisible: false,
    settleLoading: false,
    settlementForm: {
      checkDate: "", // 结算日期
      checkId: "",
      type: "2",
    }, // 结算
    searchParams: {
      dateType: '2',
      dateType1: '1'

    },
    settlementFormRules: {
      checkId: [
        {
          required: true,
          message: "请选择我司批次",
          trigger: "change",
        },
      ],
      checkDate: [
        {
          required: true,
          message: "请选择结算日期",
          type: "date",
          trigger: "change",
        },
      ]
    },
    tabList: [
      {
        label: "上游对账数据",
        value: "1",
      },
      // {
      //   label: "业务员对账数据",
      //   value: "2",
      // },
      // {
      //   label: "机构对账数据",
      //   value: "3"
      // },
    ],
    batchList: [], // 结算批次列表
    selectTreeId: "",
    addbatchVisible: false,
    addbatchForm: {},
    timeArray: [], // 承保时间
    value: "",
    type: "", // 1首年;2续期
    tabModel: "1",
    salesmanList: [],//所属业务员
    tableData: [],
    sourceList: [],
    columns: [],
    addFormRules: {
      checkDate: [
        {
          required: true,
          message: "请选择结算日期",
          type: "date",
          trigger: "change",
        },
      ],
      checkId: [
        {
          required: true,
          message: "请选择批次",
          trigger: "change",
        },
      ],
      settleDate: [
        {
          required: true,
          type: "date",
          message: "请选择结算日期",
          trigger: "change",
        },
      ],
    },
    addForm: {
      amount: "", //总保费
      billNum: "", //发票号
      checkAmount: "", //总核收金额
      checkDate: "", //核收日期
      checkType: "", //1首年核收  2、预收
      checkUser: "", //核收人
      commissionIdList: [],
      consultRemark: "", //描述
      num: "", //数量
      type: "1", //1、多条 2、单条选择
      checkId: "", //总批次id
      settleDate:''
    },
    addVisible: false,
    settlementShow:false,
    btnLoading: false,
    tableLoading: false,
    companyLists: [], //保险公司列表
  }),
  components: { selectTree },
  computed: {
    ...mapState({
      companyList: "companyListEntity", //保险公司
      // themeList: 'themeListEntity', //产品分类
    }),
  },
  activated(){
    this.getSource();
    this.showAction();
    this.getOrganizationUser(null)
    this.geCompanyList();
    this.queryTheme();
    this.settleReport();
    this.getqueryList()
    this.getList()
  },
  created() {
    // this.userInfo.userType = 4;
    this.columns = upstreamColumns;

    this.$root.$children[0].isShowLoading = false;
    this.type = 4;
    this.searchParams.reconciliationType =4;
    // 1首年费用记录; 2续期费用记录2
    if (this.type == 4) {
      // 续期传0,首期传1,固定值
      this.searchParams.isFirst = 0;
      this.searchParams.tab = '1';
    } else {
      this.searchParams.isFirst = 1;
    }
    this.initListAjax("/buz/commissionReconciliation/policy/result");
    
  },
  mounted() {
    
  },
  methods: {
    lookStatement(row){
      this.$router.push({
        name: "statementDetail",
        query: { id: row.checkId,step:row.step },
      });
    },
    changeValue(value){
      this.searchParams[value] = this.searchParams[value].replace(/^0(0+)|[^\d]+/g, '') 
      this.searchParams[value] = this.searchParams[value] && Number(this.searchParams[value])
      return this.searchParams[value]
    },
    setReqParams(params){
        // 对账类型reconciliationType，1首期基础费用，2首期梯度加费，3首年后置费用，4续期基础费用，5继续率奖金
        params.reconciliationType = '4'
    },
    // 通过机构获取业务员
    getqueryList() {
      this.$http({
        url: `/buz/commissionReconciliation/queryList`,
        type: "POST",
        data: {
          reconciliationType:'4',
          policyType:1  //policyType，保单类型 1个险 2团险
        }
      }).then((res) => {
        this.queryList = res.data;
      })
    },
    // 通过机构获取业务员
    getOrganizationUser(id) {
      this.$http({
        url: `/buz/userBase/getByOrgIds`,
        type: "POST",
        data: {
          orgaList: id ? [id] : []
        }
      }).then((res) => {
        this.salesmanList = res.data;
      })
    },
    // 结算单
    settleReport() {
      this.$http({
        url: '/buz/commissionReconciliation/querySettleReport',
        type: 'GET'
      }).then(res => {
        this.settleReportList = res.data;
      });
    },
    // 产品业务分类
    queryTheme() {
      this.$http({
        url: '/buz/commissionReconciliation/queryProductTheme',
        type: 'GET',
        data:{
          type:1
        }
      }).then(res => {
        this.themeList = res.data;
      });
    },
    changeTypeNull(){
      if(this.searchParams.sellTypeNull){
        this.searchParams.sellType=''
        this.searchParams.sellTypeIsNull = '1'
      }else{
        this.searchParams.sellTypeIsNull = ''
      }

      if(this.searchParams.reconciliationNull){
        this.searchParams.reconciliationId = ''
        this.searchParams.reconciliationIdIsNull = '1'
      }else{
        this.searchParams.reconciliationIdIsNull = ''
      }
    },
    changeDateNull(){
      if(this.searchParams.isNull){
        this.searchParams.date = []
        if(this.searchParams.dateType=='1'){
          this.searchParams.holdTimeStart = '';
          this.searchParams.holdTimeEnd = '';

          this.searchParams.insureTimeIsNull = ''
          this.searchParams.effectTimeIsNull = ''
          this.searchParams.holdTimeIsNull = '1'
        }else if(this.searchParams.dateType=='2'){
          this.searchParams.insureTimeStart = '';
          this.searchParams.insureTimeEnd = '';
          
          this.searchParams.holdTimeIsNull = ''
          this.searchParams.effectTimeIsNull = ''
          this.searchParams.insureTimeIsNull = '1'
        }else if(this.searchParams.dateType=='3'){
          this.searchParams.effectTimeStart = '';
          this.searchParams.effectTimeEnd	 = '';

          this.searchParams.holdTimeIsNull = ''
          this.searchParams.insureTimeIsNull = ''
          this.searchParams.effectTimeIsNull = '1'
        }
      }else{
        this.searchParams.holdTimeIsNull = ''
        this.searchParams.insureTimeIsNull = ''
        this.searchParams.effectTimeIsNull = ''
      }

      if(this.searchParams.isNull2){
        this.searchParams.checkDate = ''
        this.searchParams.checkDateIsNull = '1'
      }else{
        this.searchParams.checkDateIsNull = ''
      }

      if(this.searchParams.isNull3){
        this.searchParams.refundTime = []
        this.searchParams.refundTimeStart = ''
        this.searchParams.refundTimeEnd	 = ''
        this.searchParams.refundTimeIsNull = '1'
      }else{
        this.searchParams.refundTimeIsNull = ''
      }

    },
    changeDateType(){
      this.searchParams.date = []
      this.searchParams.holdTimeStart = '';
      this.searchParams.holdTimeEnd = '';

      this.searchParams.insureTimeStart = '';
      this.searchParams.insureTimeEnd = '';

      this.searchParams.effectTimeStart = '';
      this.searchParams.effectTimeEnd	 = '';
      this.changeDateNull()
    },
    changeDateType1(){
      this.searchParams.date1 = []
      this.searchParams.receivableTimeStart = '';
      this.searchParams.receivableTimeEnd	 = '';

      this.searchParams.lastPayDateStart = '';
      this.searchParams.lastPayDateEnd	= '';
    },
    changeTime(time) {
      if(this.searchParams.dateType == '1'){
        this.searchParams.holdTimeStart = time[0];
        this.searchParams.holdTimeEnd = time[1];
      }else if(this.searchParams.dateType == '2'){
        this.searchParams.insureTimeStart = time[0];
        this.searchParams.insureTimeEnd = time[1];
      }else if(this.searchParams.dateType == '3'){
        this.searchParams.effectTimeStart = time[0];
        this.searchParams.effectTimeEnd	 = time[1];
      }
    },
    changeTime1(time) {
      if(this.searchParams.dateType1 == '1'){
        this.searchParams.receivableTimeStart = time[0];
        this.searchParams.receivableTimeEnd	 = time[1];
      }else if(this.searchParams.dateType1 == '2'){
        this.searchParams.lastPayDateStart = time[0];
        this.searchParams.lastPayDateEnd	 = time[1];
      }
    },
    changeTime2(time) {
      this.searchParams.actualReceiveTimeStart = time[0];
      this.searchParams.actualReceiveTimeEnd	 = time[1];
    },
    changeTime4(time) {
      this.searchParams.refundTimeStart = time[0];
      this.searchParams.refundTimeEnd	 = time[1];
    },
    // 切换供应商类型
    changeSupplierType(value) {
      delete this.searchParams.supplierIds;
      this.supplierList = [];
      if (value == 1) {
        var url = '/buz/insuranceCompany/read/all'
      } else if (value == 2) {
        var url = '/buz/insuranceChannel/read/list'
      } else if (!value) {
        this.supplierList = [];
      }
      if (value) {
        this.$http({
          url,
          type: 'POST',
          data: {}
        }).then((res) => {
          this.supplierList = res.data;
        })
      }
      this.getList();
    },
    showAction() {
      if(!this.$units.pointAction('offline_10_3')){
        this.columns.splice(this.columns.length-1, 1);
      }
    },
    changeTabs(value) {
      if(value == 1){
        this.columns = upstreamColumns;
      }
      this.showAction();
      this.searchAjax();

    },
    //列表保险公司
    geCompanyList() {
      this.$http({
        url: '/buz/insuranceCompany/read/all',
        type: "POST",
        data:{companyType:"1"}
      }).then((res) => {
        this.companyLists = res.data;
      });
    },
    getSource() {
      this.$http({
        url: "/buz/productBase/getProductSource",
        type: "get",
      }).then((res) => {
        this.sourceList = res.data;
      });
    },
    // 生成结算周期
    generateSettle1() {
      this.settlementShow = true;
      this.$refs["addFormRef1"] && this.$refs["addFormRef1"].resetFields();
    },

    //生成结算批次
    generateSettle() {
      this.$nextTick(() => {
        this.$refs["addFormRef"] && this.$refs["addFormRef"].resetFields();
      });
      // 核收模型
      this.getSettleDetail();
      // 所有批次
      this.getCheckNo();
    },
    // 获取所有批次
    getCheckNo() {
      this.$http({
        url: "/buz/molCommissionCheck/read/allCheckNo",
        type: "POST",
        data: {
          source: this.searchParams.tab == '1'?"1":"2",
          commissionIndex:this.searchParams.commissionIndex
        },
      }).then((res) => {
        this.batchList = res.data;
      });
    },
    // 新增批次
    saveBatch() {
      this.$units.notCloseModal(this);
      this.$refs["addbatchRef"].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/buz/molCommissionCheck/add",
            type: "POST",
            data: {
              checkName: this.addbatchForm.checkName,
              commissionIndex:this.searchParams.commissionIndex,
              checkDate: this.$units.formatDate(
                this.addbatchForm.checkDate,
                "yyyy-MM-dd"
              ),
              source:this.searchParams.tab == '1'?'1':'2'
            },
          }).then((res) => {
            if (res.httpCode == 1) {
              this.$Message.success("新增成功");
              this.getCheckNo();
            }
            this.addbatchVisible = false;
          });
        }
      });
    },
    // 选择批次
    selectBatch(formData, id) {
      const data = this.batchList.find((item) => {
        return item.id == id;
      });
      this.$set(formData, "checkDate", data.checkDate);
    },
    getSettleDetail() {
      this.settleLoading = true;
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.$http({
        url: "/buz/commissionLog/getCheckModel",
        type: "post",
        data: params,
        apiPermissionCode:'offline_10_1'
      })
        .then((res) => {
          this.settleLoading = false;
          if (res.httpCode == 1) {
            this.addForm = res.data;
            this.addForm.checkDate = "";
            this.addVisible = true;
          }
        })
        .catch((e) => {
          this.settleLoading = false;
        });
    },
    // 机构树选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.policyOrgId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.policyOrgId = "";
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.policyOrgId = "";
        this.searchParams.groupId = "";
      }
    },

    //切换一级tab
    toggleBar(value) {
      console.log(value)
    },

    setListParams(params) {
      this.$units.delNull(params);
    },
    // 结算
    settlement(row) {
      this.settlementForm.commissionIdList = [row.id];
      this.settlementVisible = true;
      this.getCheckNo();
    },

    // 结算周期核查
    cycleCheck(row) {
      this.settlementShow = true;
      this.rowId = row.id;
    },

    saveSettlement() {
      this.settlementForm.type = "2";
      this.$refs['settlementFormRef'].validate((valid) => {
        if (valid) {
          this.$http({
            url: "/buz/commissionLog/batchAcceptCommission",
            type: "POST",
            data: this.settlementForm,
          }).then((res) => {
            if (res.httpCode == 1) {
              this.$Message.success("操作成功");
              this.getList();
            }
            this.settlementVisible = false;
          });
        }
      });
    },
    // 生成结算周期
    saveAddBatch() {
      this.settleLoading = true;
      this.$units.notCloseModal(this);
      this.$refs['addFormRef1'].validate((valid) => {
        if (valid) {
          let params = {}
          params.settleDate = this.$units.formatDate( this.addForm.settleDate, "yyyy-MM-dd" );
          if(this.rowId){
            params.id = this.rowId;
          }

          this.$http({
            url: '/buz/commissionLog/baseCommissionSettlement',
            type: "POST",
            data: params,
            apiPermissionCode:'offline_10_4'
          }).then((res) => {
            this.settleLoading = false;
            if (res.httpCode == 1) {
              this.$Message.success("操作成功");
              this.getList();
            }
            this.settlementShow = false;
            this.addForm.settleDate = '';
          });
        } else {
          this.settleLoading = false;
        }
      });
    },

    // 生成结算批次
    saveAddform() {
      this.settleLoading = true;
      this.$units.notCloseModal(this);
      this.addForm.type = "1";
      this.$refs['addFormRef'].validate((valid) => {
        if (valid) {
          this.$http({
            url: '/buz/commissionLog/batchAcceptCommission',
            type: "POST",
            data: this.addForm,
          }).then((res) => {
            this.settleLoading = false;
            if (res.httpCode == 1) {
              this.$Message.success("操作成功");
              this.getList();
            }
            this.addVisible = false;
          });
        } else {
          this.settleLoading = false;
        }
      });
    },
    // 新增批次
    addBatch() {
      this.addbatchVisible = true;
      this.addbatchForm = {};
    },
    // 导出
    exportForm() {
      if(this.$units.pointAction('offline_7_10_2')){
        let params = this.searchParams;
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/commissionReconciliation/exportExcel",
        type: "POST",
        data: params,
        responseType: "blob",
        forced: true,
        All: true,
        apiPermissionCode:'offline_10_2'
      })
        .then((res) => {
          this.$root.$children[0].isShowLoading = false;
          // json格式解析
          if (res.data.type == "application/json") {
            const reader = new FileReader();
            reader.onload = () => {
              let resp = JSON.parse(reader.result);
              if (resp) {
                if (resp.httpCode != 1) {
                  this.$Message.error(resp.msg ? resp.msg : "导出失败");
                  return;
                }
              }
            };
            reader.readAsText(res.data);
          } else {
            // blob格式下载
            this.$units.daochu(res);
          }
        })
        .catch((e) => {
          this.$root.$children[0].isShowLoading = false;
        });
      }else{
        this.$Message.error('无权操作，请联系您的上级')
      }
      
    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  .null{
    padding-left: 10px;
    line-height: 30px;
    white-space: nowrap;
  }
  /deep/.titleBox {
    border-bottom: 0 !important;
  }
  .tab-box {
    position: relative;
    .tools-box {
      position: absolute;
      right: 0;
      z-index: 1;
      top: 0;
    }
  }
  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ECECEC;
    }
    .ivu-tabs-ink-bar {
      display: none;
    }
    .ivu-tabs-tab {
      padding: 9px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515C6F;
    }
    .ivu-tabs-tab-active{
      position: relative;
      color: #236DFF;
      &::before {
        content: "";
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236DFF;
      }
    }
  }
}
/deep/ .tip-icon {
  margin-left: 3px;
  width: 15px;
  height: 15px;
  border-radius: 15px;
  background: transparent;
  border: 1px solid #000;
  color: #000;
  display: inline-block;
  text-align: center;
  line-height: 14px;
  font-size: 14px;
  cursor: pointer;
  top: 50%;
}
.toDetailPage{
  color: #236DFF;
  cursor: pointer;
}
.dian {
    display: inline-block;
    width: 5px;
    height: 5px;
    background: #35BF3F;
    border-radius: 50%;
    margin-right: 4px;
    &.red {
      background: #E3461F;
    }
  }
.btns {
  width: 100%;
  height: 40px;
  position: relative;
}
.btn {
  float: left;
  &:hover {
    cursor: pointer;
  }
  font-size: 12px;
  color: #236dff;
  float: left;
  padding: 0 12px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  background-color: #F7F8FA;
  color: #727c8e;
  margin-right: 10px;
  border-radius: 5px;

  &.active {
    background: #236dff;
    color: #fff;
  }
}

</style>
<style lang="scss">
.commissionRecordModal {
  .ivu-modal-footer {
    padding-top: 0;
  }
  .page-form {
    .pc-wrap {
      .ivu-form-item-content {
        display: flex;
        button {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
